export const DEFAULT_RIGHT_PANEL_SIZE = 40;
